import React, { Component } from 'react';
import ReactDOM from 'react-dom';
//import Parser from 'html-react-parser'; //imported to render html from variable, had to be installed seperately

import offerIcon from '../images/offer_icon.png';
import debitCardIcon from '../images/icons8-card_security.png';
import simplIcon from '../images/simpl-pay.png';
import paypalIcon from '../images/paypal.png';
import netBankingIcon from '../images/icons8-notebook.png';
import mobileWalletsIcon from '../images/icons8-mobile_payment.png';
import upiIcon from '../images/upi.png';
import rightArrow from '../images/right_arrow.png';
import paymentFooter from '../images/secure_payment_footer.jpg';
import leftArrow from '../images/left_arrow.png';
import Parser from 'html-react-parser';

import Swal from 'sweetalert2';

class PaymentScreen extends Component {

  constructor(props) {
    super(props);
    this.open_juspay_iframe = this.open_juspay_iframe.bind(this);
    this.page_handler_simpl = this.page_handler_simpl.bind(this); //uncomment this later
    this.page_handler_revert = this.page_handler_revert.bind(this);
    this.state = {
      juspay_iframe: 0, //value to check if iframe is to be opened
      juspay_order_link: ""
    };

    if(this.props.total_amount===0){
      this.props.main_page_change_free(6) //setting page number 6 for free events
    }
  }

  componentDidMount(){
    window.scrollTo(0, 0); //scroll to top on page change
  }

  open_juspay_iframe(juspay_order_link){
    this.setState({
      juspay_iframe: 1,
      juspay_order_link: juspay_order_link
     });
    //alert(juspay_order_link);
  }
  //uncomment this later
  page_handler_simpl(){
    this.props.main_page_change_simpl(6) //setting page number 5
  }

  page_handler_revert(){
    this.setState({
      juspay_iframe: 0
     });    
  }

  render() {

    return (
      <div id="payment_page_main_div" className={this.props.name_of_class}>
        {(() => {
                switch (this.state.juspay_iframe) {
                  case 1: return <FinalPaymentPage link_src={this.state.juspay_order_link} page_change={this.page_handler_revert}/>;
                  default: return (<div>
                            <Header />
                            <AmountDisplay total_amount={this.props.total_amount} currency_icon={this.props.event_currency_icon} />
                            <PaymentOffers sandbox_url_creator={this.props.sandbox_url_creator} />
                            <OtherPaymentOptions sandbox_url_creator={this.props.sandbox_url_creator} simpl_page_chage={this.page_handler_simpl} access_token={this.props.access_token} ticket_token={this.props.ticket_token} total_amount={this.props.total_amount} order_id={this.props.order_id} payment_selected={this.open_juspay_iframe} currency={this.props.event_currency} user_email={this.props.user_email} user_phone={this.props.user_phone} page_change_simpl={this.page_handler_simpl} />
                            <Footer />
                          </div>);
                }
        })()}
      </div>
    );
  }
}


//This is the simpl pay waala section for mobile, which am commenting right now because I need to disable it on Android
//<SimplPay access_token={this.props.access_token} total_amount={this.props.total_amount} order_id={this.props.order_id} user_email={this.props.user_email} user_phone={this.props.user_phone} page_change_simpl={this.page_handler_simpl} />


class FinalPaymentPage extends Component {
  
  componentDidMount(){
    window.scrollTo(0, 0); //scroll to top again
  }
  
  render() {
    return (<div>
      <div className="ticket_desktop_footer col-sm-9 col-sm-offset-3 col-xs-12">
        <p className="back_to_payment_mob" onClick={this.props.page_change} ><img src={leftArrow} className="left_back_icon" alt="Left Arrow Icon"/>Back To Payment Options</p>
      </div>
      <iframe src={this.props.link_src} className="juspay_iframe_mob" title="Payment | HighApe"></iframe>
    </div>);
  }
}


class Header extends Component {

  render() {
    return (
      <div className="secure_payment_header">
        Secure Payment
      </div>
    );
  }

}


class AmountDisplay extends Component {
  render() {
    var currency_icon = Parser(this.props.currency_icon);

    return (
      <div className="amount_payment_div">
        <div className="col-sm-8 col-xs-6 amount_payable_text">Amount Payable</div>
        <div className="col-sm-4 col-xs-6 total_amount_no_payable">{currency_icon} {this.props.total_amount}</div>
      </div>
    );
  }
}


class PaymentOffers extends Component {

  constructor(props) {
    super(props);
  }

  componentDidMount(){
    fetch("https://checkout-api"+this.props.sandbox_url_creator+".highape.com/android/v1/get_payment_offers", {
      method: 'GET'
    })
      .then(res => res.json())
      .then(function(result) {
          this.setState({
            payment_offers_array: result
          });
          if(this.state.payment_offers_array.length === 0){
            document.getElementById('special_payment_offers').style.display = 'none';
          }
          //console.log(result);
        }.bind(this),
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          alert(error);
        }
      ); 
  }

  showPaymentOffers(){
    var offers_to_show = "";
    for(var i = 0; i < this.state.payment_offers_array.length; i++){
      offers_to_show = offers_to_show + '<div class="payment_offer_single_div row"><div class="col-sm-12 col-xs-12"><div class="col-sm-2 col-xs-2"><img class="payment_offer_img" src="'+this.state.payment_offers_array[i]['payment_img']+'" alt="Payment Offer Image" /></div><div class="col-sm-10 col-xs-10 payment_offer_title">'+this.state.payment_offers_array[i]['payment_title']+'</div></div><div class="col-sm-12 col-xs-12 payment_offer_bold_text">'+this.state.payment_offers_array[i]['payment_bold_text']+'</div><div class="col-sm-12 col-xs-12 payment_offer_desc">'+this.state.payment_offers_array[i]['payment_desc']+'</div></div>';
    }
    Swal({
      title: 'Available Offers',
      width: 500,
      html: '<div><div class="title_swal_payment_offer"></div><div>'+offers_to_show+'</div></div>'
    });
    
  }
//
  render() {
    return (
      <div id="special_payment_offers" className="col-sm-6 col-sm-offset-3 col-xs-12 payment_offers_div_mob hide-div-paypal" onClick={() => this.showPaymentOffers()}>
        <div className="col-sm-2 col-xs-2">
          <img className="payment_icons" src={offerIcon} alt="Icon for Offers" />
        </div>
        <div className="col-sm-10 col-xs-10">
          Special Payment Offers
          <img className="right_arrow_payment_offer_mob" src={rightArrow} alt="Right arrow icon" />
        </div>
      </div>
    );
  }
}


class SimplPay extends Component {

  constructor(props) {
    super(props);
    this.state = {
      class_of_simpl: "hidden"
    };
    this.placeOrder = this.placeOrder.bind(this);
  }

  componentDidMount(){
    //Showing or hiding Simpl Button
    document.getElementById('simpl-button').style.display = 'none'; //hiding at start
    window.Simpl && window.Simpl.setTransactionAmount(
      window.Simpl.convertRupeeToPaise(this.props.total_amount)
    );
    window.Simpl && window.Simpl.setApprovalConfig({
      email: this.props.user_email,
      phone_number: this.props.user_phone

    });
    window.Simpl && window.Simpl.on('approval', function yep() {
      //show the Simpl payment option
      document.getElementById('simpl-button').style.display = 'block';
    }, function nope() {
      // hide the Simpl payment option
      document.getElementById('simpl-button').style.display = 'none';
    });
  }

  render() {
    return (
      <div>
        <div id="simpl-button" className="simpl_pay_div">
          <div className="col-sm-2 col-xs-2 payment_icon_div">
            <img className="payment_icons" src={simplIcon} alt="Icon for card payment" />
          </div>
          <div className="col-sm-10 col-xs-10 payments_other_text" onClick={() => this.getTransactionToken()}>
            Pay with SimplPay
            <img className="right_arrow_payment" src={rightArrow} alt="Right arrow icon" />
          </div>
          <div className="clearfix"></div>
        </div>
      </div>
    );
  }
//<div className="col-sm-2 col-xs-2 simpl_payment_icon_div"><img className="payment_icons" src={simplIcon} alt="Icon for SimplPay" /></div>
          //<div className="col-sm-10 col-xs-10 payments_simpl_text" onClick={() => this.getTransactionToken()}>Pay with Simpl Pay</div>
       
  placeOrder(response) {
    //console.log("https://checkout-api.highape.com/web/v1/place_simpl_order?access_token=7d45426c7fb9f9470d1cf0ef2d23b524&transaction_token="+response.transaction_token+"&order_id=" + this.props.order_id);
    
    fetch("https://checkout-api"+this.props.sandbox_url_creator+".highape.com/web/v1/place_simpl_order?access_token="+this.props.access_token+"&transaction_token="+response.transaction_token+"&order_id=" + this.props.order_id, {
      method: 'GET'
    })
      .then(res => res.json())
      .then(function(result) {
            // Expecting a JSON response from the remote server
            //var data = result.responseText;
            if (result['success']) {
              // Order is placed.
              // Redirect the user to a thank-you page.
               //Sending to confirmation screen
               this.props.page_change_simpl();
            } else {
              // Unable to place the order.
              // Show an appropriate error message to the user.
              alert(result['errors']);
            }
            
        }.bind(this),
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          alert(error);
        }
      );
  
  }

  getTransactionToken(){
    window.Simpl && window.Simpl.setTransactionAmount(
      window.Simpl.convertRupeeToPaise(this.props.total_amount)
    );
    window.Simpl && window.Simpl.authorizeTransaction();
    window.Simpl && window.Simpl.on('success', (response) => {
      // response from Simpl will include the following keys:
      // { status: 'success', transaction_token: 'xyz' }
      this.placeOrder(response);
    });
    window.Simpl && window.Simpl.on('error', function(response) {
      // response from Simpl will include the following keys:
      // { status: 'error', message: 'Something went wrong.' }
      console.log(response);
    });
  }
}


class OtherPaymentOptions extends Component {

  constructor(props){
    super(props);
    this.generateJuspayOrderid = this.generateJuspayOrderid.bind(this);
    this.page_handler_simpl = this.page_handler_simpl.bind(this);
  }

  componentDidMount(){
    //alert("111");
  }
            //<div className="payment_offer_text">
              //20% Supercash on Mobikwik, max Rs. 150. Twice per user. Offer validity: 14 Sept - 31 Oct.
            //</div>
  //<SimplPay access_token={this.props.access_token} total_amount={this.props.total_amount} order_id={this.props.order_id} user_email={this.props.user_email} user_phone={this.props.user_phone} page_change_simpl={this.props.page_change_simpl} />
        
  render() {
    //alert("111");
    return(
      <div>
        <div className="col-sm-12 col-xs-12 other_payment_div">
          Payment Options
        </div>
        <div className="payment_options_parent">
        <SimplPay sandbox_url_creator={this.props.sandbox_url_creator} access_token={this.props.access_token} total_amount={this.props.total_amount} order_id={this.props.order_id} user_email={this.props.user_email} user_phone={this.props.user_phone} page_change_simpl={this.page_handler_simpl} />

          <div className="col-sm-2 col-xs-2 payment_icon_div hide-div-paypal">
            <img className="payment_icons" src={paypalIcon} alt="Icon for Paypal" />
          </div>
          <div className="col-sm-10 col-xs-10 payments_other_text hide-div-paypal" onClick={() => this.generatePaypalOrder()}>
            Pay with PayPal
            <img className="right_arrow_payment" src={rightArrow} alt="Right arrow icon" />
          </div>
          <div className="clearfix"></div>
          <div className="col-sm-2 col-xs-2 payment_icon_div">
            <img className="payment_icons" src={debitCardIcon} alt="Icon for card payment" />
          </div>
          <div className="col-sm-10 col-xs-10 payments_other_text" onClick={() => this.generateJuspayOrderid("card")}>
            Debit/Credit Card
            <img className="right_arrow_payment" src={rightArrow} alt="Right arrow icon" />
          </div>
          <div className="clearfix"></div>
          <div className="col-sm-2 col-xs-2 payment_icon_div">
            <img className="payment_icons" src={netBankingIcon} alt="Icon for net banking payment" />
          </div>
          <div className="col-sm-10 col-xs-10 payments_other_text" onClick={() => this.generateJuspayOrderid("nb")}>
            Net Banking
            <img className="right_arrow_payment" src={rightArrow} alt="Right arrow icon" />
          </div>
          <div className="clearfix"></div>
          <div className="col-sm-2 col-xs-2 payment_icon_div">
            <img className="payment_icons" src={mobileWalletsIcon} alt="Icon for wallet payment" />
          </div>
          <div className="col-sm-10 col-xs-10 payments_other_text" onClick={() => this.generateJuspayOrderid("wallet")}>
            <div className="payment_name_offer">Mobile Wallets
              <img className="right_arrow_payment right_arrow_payment_offer" src={rightArrow} alt="Right arrow icon" />
            </div>
            <div className="payment_offer_text">
            </div>
          </div>
          <div className="clearfix"></div>
          <div className="col-sm-2 col-xs-2 payment_icon_div">
            <img className="payment_icons" src={upiIcon} alt="Icon for wallet payment" />
          </div>
          <div className="col-sm-10 col-xs-10 payments_other_text" onClick={() => this.generateJuspayOrderid("upi")}>
            UPI
            <img className="right_arrow_payment" src={rightArrow} alt="Right arrow icon" />
          </div>
        </div>
        <div className="ticket_desktop_footer col-sm-12 col-xs-12">
          <p className="below_continue_back_payment" onClick={() => this.triggerHeaderClick()} ><img src={leftArrow} className="left_back_icon" alt="Left Arrow Icon"/>Back</p>
        </div>
      </div>
    );
  }

  triggerHeaderClick() {
    document.getElementById("third_journey_main").click();
  }

  page_handler_simpl(){
    //alert("hey2")
    this.props.simpl_page_chage();
  }

  generatePaypalOrder(payment_method){
    document.getElementById("payment_page_main_div").style.display = "none";
    document.getElementById("loader-wrapper-details").style.display = "block"; //from details page
    fetch("https://checkout-api"+this.props.sandbox_url_creator+".highape.com/web/v1/initiate_paypal_payment?access_token="+this.props.access_token+"&order_id=" + this.props.order_id+"&ticket_token=" + this.props.ticket_token, {
      method: 'GET'
    })
      .then(res => res.json())
      .then(function(result) {
            // Expecting a JSON response from the remote server
            //var data = result.responseText;
            if (result['links'][1]['href']) {
              //Redirecting user to the redirect url
               window.location = result['links'][1]['href'];
            } else {
              // Unable to place the order.
              // Show an appropriate error message to the user.
              document.getElementById("loader-wrapper-details").style.display = "none"; //from details page
              document.getElementById("payment_page_main_div").style.display = "block";
              alert("Payment Option Failed. Please try another Payment Option.");
            }
            
        },
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          document.getElementById("loader-wrapper-details").style.display = "none"; //from details page
          document.getElementById("payment_page_main_div").style.display = "block";
          alert(error);
        }
      );
  }


  generateJuspayOrderid(payment_method){
       var data = "access_token="+this.props.access_token+"&order_id="+this.props.order_id+"&return_url=http://tickets.highape.com&payment_method="+payment_method;
       fetch('https://checkout-api'+this.props.sandbox_url_creator+'.highape.com/web/v1/juspay/create_order', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
          'Accept': 'application/json'
        },
        body: data
        })
      .then(function(response) {
        return response.json()
      }).then(function(body) {
          //alert(JSON.stringify(body));
          this.props.payment_selected(body["payment_links"]["web"]+"?payment_options="+payment_method);
      }.bind(this),
        // Note: it's important to handle errors here
        // instead of a catch() block so that we don't swallow
        // exceptions from actual bugs in components.
        (error) => {
          alert(error);
        }
      );

  }

  openCardDiv() {
    const card_def = <CardPayment />;
    ReactDOM.render(card_def, document.getElementById("card_payment_div"));
    //alert("hey");
  }
  
}


class CardPayment extends Component {

  render() {

    return(
      <div>
        <form className="juspay_inline_form" id="payment_form">
          <input type="hidden" className="merchant_id" value="guest"/>
          <input type="hidden" className="order_id" value="guest_order"/>
          <div className="card_number_div"></div>
          <div className="name_on_card_div"></div>
          <div className="card_exp_month_div"></div> - <div className="card_exp_year_div"></div>
          <div className="security_code_div"></div>
          <input type="checkbox"  className="juspay_locker_save"/> Save card information
          <input type="hidden" className="redirect" value="true"/>
          <input type="radio" className="auth_type" value="" name="auth_type"/> Verify with Secure Password
          <input type="radio" className="auth_type" value="ATMPIN" name="auth_type"/> Verify with ATM PIN
          <button type="submit" id="common_pay_btn">Make Payment</button>
        </form>
      </div>
    );
  }
}

class Footer extends Component {

  render() {
    return(
      <div>
       <img className="payment_footer_image" src={paymentFooter} alt="Footer for Payment Page" />
      </div>
    );
  }
}


export default PaymentScreen;


// WEBPACK FOOTER //
// ./src/mobile/mobPaymentScreen.js